import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import Invoice from "../invoice/models/invoice"
import Order from "../order/Order"
import { PROPOSAL_TYPE } from "../proposal/ProposalType"
import Quote from "../quote/Quote"

type NewDocumentFromExternalSalePayload = {
    externalId: string
    integrationKey: string
    documentType?: string
    externalContactId?: string
}

class ExternalSaleImportableService {

    static async createNewDocumentWithExternalSaleID(payload: NewDocumentFromExternalSalePayload)
        : Promise<Invoice | Quote | Order> {
        const { integrationKey, ...params } = payload
        const queryString = Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join("&")

        const res = await AppContext.getApiClient().post(`/${integrationKey}/create-new-document?${queryString}`, {})

        return new Promise((resolve, reject) => {
            if (res.error) {
                reject(new Error(res.error.message))
            } else {
                switch (payload.documentType) {
                case PROPOSAL_TYPE.INVOICE:
                    resolve(new Invoice(res))
                    return
                case PROPOSAL_TYPE.QUOTE:
                    resolve(new Quote(res))
                    return
                case PROPOSAL_TYPE.ORDER:
                    resolve(new Order(res))
                    return
                }

                reject(new Error("Invalid document type"))
            }
        })
    }
}

export default ExternalSaleImportableService


// WEBPACK FOOTER //
// ./src/state/integration/ExternalSaleImportableService.ts